// Sidecar-backed per-parcel statistics, mirroring the LULC demo's
// `parcel_attributes.json` pattern (see scripts/demo-nab-deforestation/
// build-parcel-stats.py). One JSON keyed by `cadastrePid` carries the
// breakdowns the parcel detail panel + group summary need —
// fetched once on mount, served synchronously thereafter.
//
// Schema must stay in lockstep with the `ParcelStats` types in
// ../types/deforestation.ts (the build script's output contract).

import { PARCEL_STATS_URL } from "../config/deforestation";
import type {
  BushfireRecord,
  ForestChangeStats,
  ForestClassRow,
  ParcelStats,
  RegulatoryVegRow,
} from "../types/deforestation";

// Re-export the types for callers that previously imported them from
// here (parcel-detail-panel.tsx etc.). Aliasing the row types keeps the
// "ClassCoverage" name the older code used.
export type {
  BushfireRecord,
  ForestChangeStats,
  ParcelStats,
  RegulatoryVegRow,
};
export type ClassCoverage = ForestClassRow;

let sidecar: Record<string, ParcelStats> | null = null;
let sidecarPromise: Promise<Record<string, ParcelStats>> | null = null;

export function ensureParcelStats(): Promise<Record<string, ParcelStats>> {
  if (sidecar) return Promise.resolve(sidecar);
  if (sidecarPromise) return sidecarPromise;
  sidecarPromise = fetch(PARCEL_STATS_URL)
    .then((res) => {
      if (!res.ok) {
        throw new Error(
          `parcel-stats sidecar fetch failed: ${res.status} ${res.statusText}`,
        );
      }
      return res.json();
    })
    .then((data: Record<string, ParcelStats>) => {
      sidecar = data;
      return data;
    })
    .catch((err) => {
      console.error("[nab-deforestation] parcel stats load failed:", err);
      sidecar = {};
      return sidecar;
    });
  return sidecarPromise;
}

export function getParcelStats(cadastrePid: string): ParcelStats | null {
  return sidecar?.[cadastrePid] ?? null;
}
